let requestApplyConfirmFn = null;

export function registerConnorsApplyConfirmRequest(fn) {
  requestApplyConfirmFn = fn;
}

export function requestConnorsApplyConfirm(onConfirm) {
  if (typeof onConfirm !== "function") {
    return;
  }

  if (requestApplyConfirmFn) {
    requestApplyConfirmFn(onConfirm);
    return;
  }

  onConfirm();
}
